// components
import { FormsIDidFilters } from "./components/FormsIDidFilterPanel";

export const getFiltersForSearchService = (filters: FormsIDidFilters, userId: string, searchTerm?: string) => {
	const baseFilters = {
		past_authors_or_past_signers_eq: userId,
		form_name_re: searchTerm,
	};

	if (filters.subject) {
		baseFilters["subject_eq"] = filters.subject.id;
	}

	if (filters.status && filters.status !== "any") {
		baseFilters["status_eq"] = [filters.status];
	}

	return baseFilters;
};
